import React, { useState } from "react";

//const FORM_ENDPOINT = "http://0.0.0.0:8000/reservation";
let FORM_ENDPOINT = "https://inscription-utuvyi37ea-ew.a.run.app/reservation";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        last_name: "",
        first_name: "",
        email: "",
        phone_number: ""
    });

    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code") || "";
    const activite = queryParams.get("activite") || "";
    let id_inscription = "";

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const headers = {
                'Content-Type': 'application/json',
                'Service-Ulid': '01H87HYXC4EVK7E0N75D2K9DTZ',
                'Accept': '*/*',
            }

            const payload = JSON.stringify(formData)

            console.log("Data to send:", payload)

            const requestOptions = {
                method: 'POST',
                headers: headers,
                body: payload
            };

            const response = await fetch(FORM_ENDPOINT, requestOptions);
            const data = await response.json();
            //this.setState({ postId: data.id });


            console.log("Response from server:", data);
            id_inscription = data._id;

            // change html content
            document.getElementById("formulaire").innerHTML = "<h1> Merci pour votre inscription ! </h1><ul><li>ref : " + data._id + "</li><li>" + data.first_name + " " + data.last_name + "</li></ul>";
            //document.getElementById("listing").innerHTML = "";

        } catch (error) {
            console.error("Error:", error);
        }

        try {
            let FORM_ENDPOINT_2 = "https://api.pebble.solutions/v5/activity/" + activite + "/group/" + code + "/registration/" + id_inscription;

            const headers = {
                'Content-Type': 'application/json',
                'Accept': '*/*',
            }

            const requestOptions = {
                method: 'POST',
                headers: headers,
            };

            const response = await fetch(FORM_ENDPOINT_2, requestOptions);
            const data2 = await response.json();
            console.log("Response from server:", data2);
        }
        catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <form
            action={FORM_ENDPOINT}
            onSubmit={handleSubmit}
            method="POST"
            id="formulaire"
        >
            <input type="hidden" name="code" value={code}/>
            <input type="hidden" name="activite" value={activite}/>
            <div className="pt-0 mb-3">
                <input
                    type="text"
                    placeholder="Nom"
                    name="last_name"
                    value={formData.last_name} // Set input value to the corresponding state value
                    onChange={(e) => setFormData({ ...formData, last_name: e.target.value })} // Update state when input changes
                    className="focus:outline-none focus:ring relative w-full px-3 py-3 text-sm text-gray-600 placeholder-gray-400 bg-white border-0 rounded shadow outline-none"
                    required
                />
            </div>
            <div className="pt-0 mb-3">
                <input
                    type="text"
                    placeholder="Prénom"
                    name="first_name"
                    value={formData.first_name} // Set input value to the corresponding state value
                    onChange={(e) => setFormData({ ...formData, first_name: e.target.value })} // Update state when input changes
                    className="focus:outline-none focus:ring relative w-full px-3 py-3 text-sm text-gray-600 placeholder-gray-400 bg-white border-0 rounded shadow outline-none"
                    required
                />
            </div>
            <div className="pt-0 mb-3">
                <input
                    type="text"
                    placeholder="Email"
                    name="email"
                    value={formData.email} // Set input value to the corresponding state value
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })} // Update state when input changes
                    className="focus:outline-none focus:ring relative w-full px-3 py-3 text-sm text-gray-600 placeholder-gray-400 bg-white border-0 rounded shadow outline-none"
                    required
                />
            </div>
            <div className="pt-0 mb-3">
                <input
                    type="text"
                    placeholder="Téléphone"
                    name="phone_number"
                    value={formData.phone_number} // Set input value to the corresponding state value
                    onChange={(e) => setFormData({ ...formData, phone_number: e.target.value })} // Update state when input changes
                    className="focus:outline-none focus:ring relative w-full px-3 py-3 text-sm text-gray-600 placeholder-gray-400 bg-white border-0 rounded shadow outline-none"
                    required
                />
            </div>
            <div className="pt-0 mb-3">
                <button
                    className="active:bg-blue-600 hover:shadow-lg focus:outline-none px-6 py-3 mb-1 mr-1 text-sm font-bold text-white transition-all duration-150 ease-linear bg-blue-500 rounded shadow outline-none"
                    type="submit"
                >
                    Je m'inscris !
                </button>
            </div>
        </form>
    );
};

export default ContactForm;